export const findMenuItemById = (items: any, targetId: string) => {
  for (const item of items) {
    if (item.id === targetId) {
      return item;
    }
    if (item.children && Array.isArray(item.children)) {
      const foundItem: any = findMenuItemById(item.children, targetId);
      if (foundItem) {
        return foundItem;
      }
    }
  }
  return null;
};
